module.exports = __webpack_public_path__ + "media/images/element/03-91314f7d2df149df2e468073005bc2b0.svg";